module.exports = __webpack_public_path__ + "static/gatel-o-logo-5cadc0c446f2831f0731a4d846f8622a.png";